module.exports = __webpack_public_path__ + "img/zynlc.d2793e35.png";